var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61518 10C11.5716 10 13.1576 8.433 13.1576 6.5C13.1576 4.56701 11.5716 3 9.61518 3C7.65875 3 6.07275 4.56701 6.07275 6.5C6.07275 8.433 7.65875 10 9.61518 10Z",
    stroke: "#898989",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5015 3.5C17.5302 4.11245 18.2182 5.22685 18.2182 6.5C18.2182 7.77315 17.5302 8.88755 16.5015 9.5",
    stroke: "#898989",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.02441 20.4V21H17.2062V20.4C17.2062 18.1598 17.2062 17.0397 16.765 16.184C16.3769 15.4314 15.7575 14.8195 14.9957 14.436C14.1297 14 12.996 14 10.7287 14H8.50199C6.23464 14 5.10096 14 4.23493 14.436C3.47315 14.8195 2.85381 15.4314 2.46567 16.184C2.02441 17.0397 2.02441 18.1598 2.02441 20.4Z",
    stroke: "#898989",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2667 21V20.4C22.2667 18.1598 22.2667 17.0397 21.8254 16.1841C21.4373 15.4314 20.8179 14.8195 20.0562 14.436",
    stroke: "#898989",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabUser);
export default __webpack_public_path__ + "static/media/tabUser.7486a92715e0f3584ac93bac7405f49f.svg";
export { ForwardRef as ReactComponent };